/**
 * The text sizes a recipe can be read at, smallest first. The Large Text button steps through
 * them and wraps back to the first, so one button is enough to reach every size.
 */
export const RECIPE_TEXT_SIZES = [
  { scale: 1, label: 'Normal' },
  { scale: 1.4, label: 'Large' },
] as const;

/** A device setting rather than household data, so both clients keep it in local storage. */
export const RECIPE_TEXT_SIZE_KEY = 'platewell.recipeTextSize';

export function nextRecipeTextSize(index: number): number {
  return (index + 1) % RECIPE_TEXT_SIZES.length;
}

/** Reads a stored index, falling back to Normal for anything missing or out of range. */
export function parseRecipeTextSize(raw: string | null | undefined): number {
  const index = Number(raw);
  return Number.isInteger(index) && index >= 0 && index < RECIPE_TEXT_SIZES.length ? index : 0;
}
